import { render, staticRenderFns } from "./PortPopup.vue?vue&type=template&id=5688b98c&scoped=true&"
import script from "./PortPopup.vue?vue&type=script&lang=js&"
export * from "./PortPopup.vue?vue&type=script&lang=js&"
import style0 from "./PortPopup.vue?vue&type=style&index=0&id=5688b98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688b98c",
  null
  
)

export default component.exports